(function(){
  const $=(s,root=document)=>root.querySelector(s);
  const $$=(s,root=document)=>Array.from(root.querySelectorAll(s));
  document.addEventListener('click',e=>{
    const menu=e.target.closest('[data-menu-toggle]');
    if(menu){
      const m=$('#MobileMenu');
      if(m){
        m.classList.toggle('open');
        menu.setAttribute('aria-expanded',m.classList.contains('open')?'true':'false');
      }
    }
  });
  $$('[data-variant-select]').forEach(sel=>{
    sel.addEventListener('change',()=>{
      const opt=sel.selectedOptions[0];
      const wrap=sel.closest('[data-product-form-wrap]')||document;
      const price=wrap.querySelector('[data-variant-price]');
      if(price&&opt.dataset.price) price.textContent=opt.dataset.price;
    });
  });
})();


// Improve touch/trackpad handling for mobile vertical swipe stacks.
(function(){
  const mobileQuery = window.matchMedia('(max-width: 740px)');
  const selectors = ['.featured-grid','.home-product-grid','.services-grid','.plates-grid','.services-list-grid','.product-grid'];
  function markSwipeStacks(){
    if(!mobileQuery.matches) return;
    selectors.forEach(sel=>{
      document.querySelectorAll(sel).forEach(el=>{
        if(el.dataset.verticalSwipeReady) return;
        el.dataset.verticalSwipeReady = 'true';
        el.setAttribute('tabindex','0');
        el.setAttribute('aria-label', el.getAttribute('aria-label') || 'Swipe vertically to view more items');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', markSwipeStacks);
  if(mobileQuery.addEventListener) mobileQuery.addEventListener('change', markSwipeStacks);
})();

// Horizontal mobile carousel for the "Compatible With" brand logos.
(function(){
  const mobileQuery = window.matchMedia('(max-width: 740px)');
  function initBrandCarousels(root){
    (root || document).querySelectorAll('[data-brand-carousel]').forEach(carousel=>{
      const track = carousel.querySelector('[data-brand-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-brand-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-brand-dot]'));
      if(!track || !slides.length || carousel.dataset.brandCarouselReady) return;
      carousel.dataset.brandCarouselReady = 'true';
      function goTo(index){
        const target = slides[index];
        if(!target) return;
        track.scrollTo({left: target.offsetLeft - track.offsetLeft, behavior: 'smooth'});
      }
      function setActive(){
        if(!mobileQuery.matches) return;
        const trackLeft = track.scrollLeft;
        let active = 0;
        let smallest = Infinity;
        slides.forEach((slide,index)=>{
          const distance = Math.abs((slide.offsetLeft - track.offsetLeft) - trackLeft);
          if(distance < smallest){smallest = distance; active = index;}
        });
        dots.forEach((dot,index)=>dot.classList.toggle('is-active', index === active));
      }
      dots.forEach((dot,index)=>dot.addEventListener('click',()=>goTo(index)));
      track.addEventListener('scroll',()=>window.requestAnimationFrame(setActive),{passive:true});
      window.addEventListener('resize',setActive,{passive:true});
      setActive();
    });
  }
  document.addEventListener('DOMContentLoaded',()=>initBrandCarousels(document));
  document.addEventListener('shopify:section:load',event=>initBrandCarousels(event.target));
})();

// Horizontal mobile carousel behavior for product/service/plate grids with dot indicators.
(function(){
  const mobileQuery = window.matchMedia('(max-width: 740px)');
  const selectors = [
    '.featured-grid',
    '.home-product-grid',
    '.services-grid',
    '.plates-grid',
    '.services-list-grid',
    '.collection .product-grid',
    '.section .product-grid',
    '.product-grid:not(.home-product-grid)'
  ];

  function isBrandTrack(el){
    return el.closest('[data-brand-carousel]') || el.matches('.brand-grid');
  }

  function initGridCarousel(grid){
    if(!grid || isBrandTrack(grid)) return;
    const items = Array.from(grid.children).filter(el => el.nodeType === 1 && !el.classList.contains('mobile-grid-dots'));
    if(items.length < 2) return;

    grid.setAttribute('tabindex','0');
    grid.setAttribute('aria-label','Swipe horizontally to view more items');

    let dotsWrap = grid.nextElementSibling;
    if(!dotsWrap || !dotsWrap.classList.contains('mobile-grid-dots')){
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'mobile-grid-dots';
      dotsWrap.setAttribute('aria-hidden','false');
      grid.insertAdjacentElement('afterend', dotsWrap);
    }

    if(dotsWrap.dataset.count !== String(items.length)){
      dotsWrap.innerHTML = '';
      dotsWrap.dataset.count = String(items.length);
      items.forEach((_, index)=>{
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mobile-grid-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to item ' + (index + 1));
        dot.addEventListener('click', ()=>{
          const target = items[index];
          if(!target) return;
          grid.scrollTo({left: target.offsetLeft - grid.offsetLeft, behavior:'smooth'});
        });
        dotsWrap.appendChild(dot);
      });
    }

    const dots = Array.from(dotsWrap.querySelectorAll('.mobile-grid-dot'));
    function updateDots(){
      if(!mobileQuery.matches){
        dotsWrap.style.display = 'none';
        return;
      }
      dotsWrap.style.display = '';
      const left = grid.scrollLeft;
      let active = 0;
      let smallest = Infinity;
      items.forEach((item,index)=>{
        const distance = Math.abs((item.offsetLeft - grid.offsetLeft) - left);
        if(distance < smallest){smallest = distance; active = index;}
      });
      dots.forEach((dot,index)=>dot.classList.toggle('is-active', index === active));
    }

    if(!grid.dataset.horizontalSwipeReady){
      grid.dataset.horizontalSwipeReady = 'true';
      grid.addEventListener('scroll',()=>window.requestAnimationFrame(updateDots),{passive:true});
      window.addEventListener('resize',updateDots,{passive:true});
    }
    updateDots();
  }

  function initAll(root){
    (root || document).querySelectorAll(selectors.join(',')).forEach(initGridCarousel);
  }

  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  if(mobileQuery.addEventListener) mobileQuery.addEventListener('change',()=>initAll(document));
})();


// Swipeable product gallery: no popup/zoom, thumbnails and dots control the main image slider.
(function(){
  function initProductGallery(gallery){
    if(!gallery || gallery.dataset.swipeGalleryReady) return;
    const slider = gallery.querySelector('[data-product-slider]');
    if(!slider) return;

    gallery.dataset.swipeGalleryReady = 'true';
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));

    function getActiveIndex(){
      const left = slider.scrollLeft;
      let active = 0;
      let smallest = Infinity;
      slides.forEach((slide,index)=>{
        const distance = Math.abs(slide.offsetLeft - left);
        if(distance < smallest){ smallest = distance; active = index; }
      });
      return active;
    }

    function setActive(index, shouldScroll){
      if(!slides.length) return;
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if(shouldScroll){
        slides[safeIndex].scrollIntoView({behavior:'smooth', inline:'start', block:'nearest'});
      }
      slides.forEach((slide,i)=>slide.classList.toggle('is-active', i === safeIndex));
      thumbs.forEach((thumb,i)=>{
        thumb.classList.toggle('is-active', i === safeIndex);
        if(i === safeIndex){
          thumb.setAttribute('aria-current','true');
          thumb.scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      dots.forEach((dot,i)=>dot.classList.toggle('is-active', i === safeIndex));
    }

    thumbs.forEach((thumb,index)=>{
      thumb.addEventListener('click', event=>{
        event.preventDefault();
        setActive(index, true);
      });
    });
    dots.forEach((dot,index)=>{
      dot.addEventListener('click', event=>{
        event.preventDefault();
        setActive(index, true);
      });
    });

    let ticking = false;
    slider.addEventListener('scroll', ()=>{
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(()=>{
        setActive(getActiveIndex(), false);
        ticking = false;
      });
    }, {passive:true});

    slider.addEventListener('keydown', event=>{
      const active = getActiveIndex();
      if(event.key === 'ArrowRight'){
        event.preventDefault();
        setActive(active + 1, true);
      }
      if(event.key === 'ArrowLeft'){
        event.preventDefault();
        setActive(active - 1, true);
      }
    });

    setActive(0, false);
  }

  function initAll(root){
    (root || document).querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
  }

  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
